import type {
  CertificateTheme,
  ProductInterval,
  ScopeThreeCategoryEnum,
} from "@s2z-platform/constants";
import type { YYYYMMDateString, YYYYMMDDDateString } from "../../common";

export class YYYYMMDDDateRange {
  start: YYYYMMDDDateString;
  end: YYYYMMDDDateString;
}

/** Configure how subscription impact purchases are dated */
export class SequentialCoverageJSON {
  /** First month to cover, e.g. "2022-12-01" */
  from: YYYYMMDDDateString;
  /** Number of months each payment's quantity is spread across */
  monthsPerPayment: number;
}

export class RecurringConfigJSON {
  sequentialCoverage: SequentialCoverageJSON;
}

export class CustomerFootprintConfig {
  offsetFootprint: boolean;
  period: YYYYMMDDDateRange;
  /** only to be used by recurring products */
  recurringConfig?: RecurringConfigJSON;
}

export class CustomerCertificateConfig {
  hideCost: boolean;
  // TODO: make themes type, and import to front (1 source of truth)
  theme: CertificateTheme = "standard";
  reference?: string;
}

export class CustomerIdentifierChoiceJSON {
  identifier: string;
  quantity: number;
}

class SharedCustomerConfigJSON {
  footprintConfig?: CustomerFootprintConfig;
  certificateConfig?: CustomerCertificateConfig;
}

export class MileageDetailsJSON {
  years: number;
  effectiveStartDate: YYYYMMDateString;
}

export class EcommerceIntegrationCustomerConfigJSON {
  countOrdersFromStoreCreation?: boolean;
}

export class PresetCustomerConfigJSON extends SharedCustomerConfigJSON {
  plansConfig: CustomerIdentifierChoiceJSON[];
}
export class CustomCustomerConfigJSON extends SharedCustomerConfigJSON {
  optionsConfig: CustomerIdentifierChoiceJSON[];
}
export class UsageCustomerConfigJSON extends SharedCustomerConfigJSON {
  usageConfig: EcommerceIntegrationCustomerConfigJSON;
}
export class CarbonVehicleCustomerConfigJSON extends SharedCustomerConfigJSON {
  vehicleUuids: string[];
  mileageDetails: MileageDetailsJSON;
}
export class OfferCustomerConfigJSON extends CustomCustomerConfigJSON {
  offerConfig: { eventName: string; offerCode?: string };
}

export class FlatRateCustomerConfigJSON {}

// should match product's config
export const BASE_PRODUCT_IDENTIFIER_SCOPE_1_2 =
  "verify_footprint_scopes_one_two";
export const BASE_PRODUCT_IDENTIFIER_SCOPE_3_CAT =
  "verify_footprint_scope_three_category";

export class VerifyScopeOneAndTwoCustomerIdentifierChoiceJSON {
  identifier: typeof BASE_PRODUCT_IDENTIFIER_SCOPE_1_2;
  quantity: number;
}

export class VerifyScopeThreeCategoryCustomerIdentifierChoiceJSON {
  identifier: typeof BASE_PRODUCT_IDENTIFIER_SCOPE_3_CAT;
  quantity: number;
  category: ScopeThreeCategoryEnum;
}

export class VerifyFootprintCustomerConfigJSON {
  footprintUuid: string;

  optionsConfig: (
    | VerifyScopeOneAndTwoCustomerIdentifierChoiceJSON
    | VerifyScopeThreeCategoryCustomerIdentifierChoiceJSON
  )[];
}

export class ConsultancyCustomerConfigJSON {
  consultancyConfig: {
    stripeProductId: string;
    serviceProductName: string;
    quantity: number;
    interval: ProductInterval;
  }[];
}

export class UnrecognisedProductCustomerConfigJSON {
  unrecognisedConfig: {
    stripeProductId: string;
    impactProductName?: string;
    serviceProductName?: string;
    quantity: number;
    interval: ProductInterval;
  }[];
}

export type CustomerConfigJSON =
  | PresetCustomerConfigJSON
  | CustomCustomerConfigJSON
  | UsageCustomerConfigJSON
  | CarbonVehicleCustomerConfigJSON
  | OfferCustomerConfigJSON
  | FlatRateCustomerConfigJSON
  | VerifyFootprintCustomerConfigJSON
  | ConsultancyCustomerConfigJSON
  | UnrecognisedProductCustomerConfigJSON;
